import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const CampaignsIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 58,
  height = 58,
  ...rest
}) => {
  return (
    <Icon
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <defs>
        <path id="a" d="M0 0h10.249v8.683H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          d="m11.796 46.293-.485.485a2.333 2.333 0 1 1-3.3-3.299l.486-.485"
          className={styles.white}
        />
        <path
          stroke="#424242"
          strokeWidth="1.5"
          d="m11.796 46.293-.485.485a2.333 2.333 0 1 1-3.3-3.299l.486-.485"
        />
        <path
          fill="#FFF"
          d="M30.6 19.29a3.377 3.377 0 1 1 4.777 4.776"
          className={styles.white}
        />
        <path
          stroke="#424242"
          strokeWidth="1.5"
          d="M30.6 19.29a3.377 3.377 0 1 1 4.777 4.776"
        />
        <path
          fill="#FFF"
          d="M21.649 12.055a1.1 1.1 0 0 0 0 1.553l.166.165c-3.253 14.597-7.86 18.398-7.86 18.398l.553-.552-6.67 6.67a2.86 2.86 0 0 0 0 4.046l4.376 4.376a2.864 2.864 0 0 0 4.047 0l1.329-1.329 8.393 10.298a1.09 1.09 0 0 0 1.543 0l2.409-2.41a1.09 1.09 0 0 0 0-1.543l-8.011-10.679.453-.454c7.949-6.735 15.788-7.627 18.54-7.719l.306.308a1.098 1.098 0 1 0 1.553-1.553L23.202 12.055a1.1 1.1 0 0 0-1.553 0"
          className={styles.white}
        />
        <path
          stroke="#424242"
          strokeWidth="2.5"
          d="M21.649 12.055a1.1 1.1 0 0 0 0 1.553l.166.165c-3.253 14.597-7.86 18.398-7.86 18.398l.553-.552-6.67 6.67a2.86 2.86 0 0 0 0 4.046l4.376 4.376a2.864 2.864 0 0 0 4.047 0l1.329-1.329 8.393 10.298a1.09 1.09 0 0 0 1.543 0l2.409-2.41a1.09 1.09 0 0 0 0-1.543l-8.011-10.679.453-.454c7.949-6.735 15.788-7.627 18.54-7.719l.306.308a1.098 1.098 0 1 0 1.553-1.553L23.202 12.055a1.1 1.1 0 0 0-1.553 0Z"
        />
        <path
          fill="#008CC7"
          d="m32.465 14.198.097-5.616a.223.223 0 0 0-.265-.22l-3.716.679c-.17.03-.31-.131-.252-.291l2.782-7.604c.083-.227.425-.176.435.066l.196 4.827a.224.224 0 0 0 .285.203l2.738-.763c.17-.047.327.109.276.275zM37.7 18.487l3.003-4.771a.226.226 0 0 0-.118-.333L37.06 12.11a.226.226 0 0 1-.067-.39l6.31-5.106c.196-.16.472.064.35.284l-2.32 4.205a.226.226 0 0 0 .144.328l2.727.712a.226.226 0 0 1 .097.388z"
        />
        <g transform="translate(42.553 17.617)">
          <mask id="b" fill="#fff">
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#a" />
          </mask>
          <path
            fill="#008CC7"
            d="m0 8.683 4.691-3.189a.23.23 0 0 0 .029-.36l-2.7-2.54a.231.231 0 0 1 .099-.393L9.945.011c.251-.072.417.25.211.407l-3.812 2.92a.23.23 0 0 0-.001.366l2.194 1.713a.231.231 0 0 1-.07.403z"
            mask="url(#b)"
          />
        </g>
        <path
          stroke="#424242"
          strokeWidth="1.5"
          d="m13.484 32.642 8.956 9.608M15.607 31.619l7.933 8.431M21.194 14.895l18.15 18.15"
        />
        <path
          fill="#424242"
          d="m12.465 32.642 1.668-2.284 1.162-.631.757 1.68-2.113 2.08z"
        />
      </g>
    </Icon>
  )
}
